import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { LookupInfo } from '../model/lookup.model';
import { GlobalService } from '../service/global.service';
import {
  environment
} from 'src/environments/environment';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { CompanyInfo } from '../model/company.model';
import { LeadTansactionInfo } from '../model/leadtansaction.model';
import { ProjectSaleAttachmentInfo } from '../model/projectsaleattachment.model';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-worklist-sale-close-deal-form',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './worklist-sale-close-deal-form.component.html',
  styleUrls: ['./worklist-sale-close-deal-form.component.css']
})
export class WorklistSaleCloseDealFormComponent implements OnInit {
  // callback to load worklist
  @Output() callbackloadworklist = new EventEmitter();

  // callback to set title modal and detail
  @Output() UpdateValueModal = new EventEmitter<{ titlemodal: string, detailmodal: string }>();
  //variable input from parent component
  @Input() CloseDealForm: FormGroup;
  @Input() WorklistProjectSaleList: ProjectSaleInfo[] = []
  @Input() displayiconback: boolean = false

  // list attach file project sale
  ProjectSaleAttachmentList: ProjectSaleAttachmentInfo[] = []

  // variable for loading
  displayloading: boolean = false;
  Msgloadding: string = '';


  // variable flag insert update
  isOnUpdate: boolean;
  isSubmitted: any;
  hidProjectSaleId: number;
  hideProjectSaleOnHand: string = "";
  hideProjectSaleRequestTypeCode: string = "";
  hideProjectSaleCloseDeaWFStatusCodeCurrent: string = "";
  // variable modal
  titlemodal: string
  detailmodal: string

  // Zone Rest API variable
  baseurl: string;

  // Zone Activity Log
  LeadTransaction: LeadTansactionInfo[] = []
  //Route parameters
  _ProjectCode: string;
  _RequestId: string;
  _EmpCode: string;
  _Status: string;
  isReSubmit: boolean = false;

  // Temp Var
  tempvariable: string;

  RadioVal: string = null;
  RadioValChoice: string = "N";

  constructor(private httpClient: HttpClient, private formBuilder: FormBuilder, private GlobalService: GlobalService, private route: Router, private router: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    //Set param
    this.router.params.subscribe(params => {
      this._ProjectCode = params['ProjectCode'];
      this._RequestId = params['Request'];
      this._Status = params['Status'];
    });
    //GlobalService.CheckPagingAccessRights();
  }
  ngOnInit(): void {
    this._EmpCode = localStorage.getItem("EmpCode");
    if (this.WorklistProjectSaleList.length == 0) {

      this.CloseDealForm = this.formBuilder.group({
        ProjectSaleCode: [null],
        ProjectSaleName: [null],
        ProjectSaleCompany: [null],
        ProjectSaleEstimatePrice: [null, Validators.required],
        ProjectSaleActualPrice: [null, Validators.required],
        ProjectSaleEstimateTime: [null, Validators.required],
        PorjectSaleCommission: [null, Validators.required],
        Commissiontotal: [null],
        ProjectStartDealDate: [null],
        ProjectEndDealDate: [null],
        ProjectHeadSale: [null],
        ProjectLeadOwner: [null],
        Comment: [null],
        ddlPhase2: [null],
      },
        {
          // Used custom form validator 
          validator: []
        }

      );
      this.LoadProjectSaleDetails();
    }
      
  }


  async Click_onViewforUpdateClosedealApprove(id) {
    $('#WorklistZone').hide();
    $('#LeadApprovalZone').hide();

    this.CloseDealForm.reset();
    this.isOnUpdate = true;

    let index = this.WorklistProjectSaleList.findIndex(x => x.ProjectSaleId == id);

   
    this.CloseDealForm.patchValue({
      ProjectSaleCode: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleCode),
      ProjectSaleName: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleName),
      ProjectSaleCompany: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleCompanyDisplay),
      ProjectSaleEstimatePrice: this.WorklistProjectSaleList[index].ProjectSaleEstimatePrice != null ? this.WorklistProjectSaleList[index].ProjectSaleEstimatePrice : 0,
      ProjectSaleActualPrice: this.WorklistProjectSaleList[index].ProjectSaleActualPrice != null ? this.WorklistProjectSaleList[index].ProjectSaleActualPrice : 0,
      ProjectSaleEstimateTime: this.WorklistProjectSaleList[index].ProjectSaleEstimateTime != null ? this.WorklistProjectSaleList[index].ProjectSaleEstimateTime : 0,
      PorjectSaleCommission: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].PorjectSaleCommission) != null ? parseInt(this.WorklistProjectSaleList[index].PorjectSaleCommission) : 0,
      ProjectStartDealDate: this.GlobalService.formatDate(this.WorklistProjectSaleList[index].ProjectStartDealDate),
      ProjectEndDealDate: this.GlobalService.formatDate(this.WorklistProjectSaleList[index].ProjectEndDealDate),
      ProjectHeadSale: '',
      ProjectLeadOwner: this.GlobalService.checkUndefinedString(this.WorklistProjectSaleList[index].ProjectSaleDisplayCreateBy),
    });

    this.hideProjectSaleRequestTypeCode = this.WorklistProjectSaleList[index].ProjectSaleRequestTypeCode;
    this.hideProjectSaleCloseDeaWFStatusCodeCurrent = this.WorklistProjectSaleList[index].ProjectSaleCloseDeaWfstatus;

    this.GetCommissionActualPrice();

    this.hidProjectSaleId = this.WorklistProjectSaleList[index].ProjectSaleId
    this.hideProjectSaleOnHand = this.WorklistProjectSaleList[index].ProjectSaleOnHand

    this.LoadProjectSaleAttachfileList().then(data => {
      this.ProjectSaleAttachmentList = data;

      // set progress 100 for attach file from database
      this.ProjectSaleAttachmentList.forEach((item, index) => {
        item.progress = 100;
      });
    });

    //load current transaction log list
    this.LoadTansaction('2', id).then((data) => {
      this.LeadTransaction = data;
    });

    this.LoadCountTansaction('2', id);

    $('#CloseDealZone').show();

  }

  LoadRequestFinished(page: any): void {
    this.currentPageNumber_LeadTransac = page.currentPageNumber;

    this.LoadTansaction("2", this.hidProjectSaleId).then((data) => {
      this.LeadTransaction = data;
    });
    this.LoadCountTansaction("2", this.hidProjectSaleId);
  }

  async SubmitWorklist() {
    if (this.CloseDealForm.valid) {
      this.hideProjectSaleOnHand = "" // set hideOnHand to empty for diabled all control
      this.loading(true, 'Submiting ...');
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this.hidProjectSaleId;
        objectjson['ProjectSaleEstimatePrice'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleEstimatePrice'].value) != "" ? this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleEstimatePrice'].value) : null;
        objectjson['ProjectSaleActualPrice'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleActualPrice'].value) != "" ? this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleActualPrice'].value) : null;
        objectjson['ProjectSaleEstimateTime'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleEstimateTime'].value) != "" ? this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleEstimateTime'].value) : null;
        objectjson['PorjectSaleCommission'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['PorjectSaleCommission'].value);


        objectjson['ProjectSaleRequestTypeCode'] = this.hideProjectSaleRequestTypeCode;
        objectjson['Action'] = $('input[name="RadioAction"]:checked').val();
        objectjson['Comment'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['Comment'].value);
        objectjson['ProjectSaleCloseDeaWFStatusCodeCurrent'] = this.hideProjectSaleCloseDeaWFStatusCodeCurrent;


        objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSaleWorklist", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.loading(false);

            this.titlemodal = 'Submit lead approval fail.';
            this.detailmodal = 'Your task was submit fail.';

            this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });


            $('#ModalError').modal();

          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.loading(false);
              this.titlemodal = 'Close Deal Request has been approved';
              this.detailmodal = '';

              this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });

              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').removeClass().addClass('modal-header bg-gold');
              $('#ModalComplate').modal();

              setTimeout(() => {
                $('#ModalComplate').modal('hide');
                this.Click_onBacktoWorklist();
              }, 3000);
            }

          )
      }
    } else {
      this.GlobalService.validateAllFormFields(this.CloseDealForm);
      $('input.ng-invalid')[0].focus()
    }

  }

  Click_onBacktoWorklist() {
    this.callbackloadworklist.emit(); //load worklist
    $('#CloseDealZone').hide();
    $('#LeadApprovalZone').hide();
    $('#WorklistZone').show();
    this.isOnUpdate = false;
  }



  // Call Rest api for load ProjectSale Attach file list by projectsaleid
  async LoadProjectSaleAttachfileList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleId'] = this.hidProjectSaleId;


      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectSaleAttachmentInfo[]>(this.baseurl + "ProjectSaleAttachment/GetProjectSaleAttachment",
          strjson, httpOptions)
        .toPromise()
    }
  }

  // load current tansaction log list
  totalLeadTransaction: number;
  totalPages_LeadTransac: number;
  currentPageNumber_LeadTransac: number = 1;
  async LoadTansaction(RequestType, ProjectSaleId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_LeadTransac - 1) * environment.PageSizeSmall;

      var objectjson = {};
      objectjson['LeadTansactionProjectSaleRequestType'] = RequestType;
      objectjson['LeadTansactionProjectSaleId'] = ProjectSaleId;

      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LeadTansactionInfo[]>(this.baseurl + "LeadTansaction/GetLeadTansaction", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountTansaction(RequestType, ProjectSaleId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LeadTansactionProjectSaleRequestType'] = RequestType;
      objectjson['LeadTansactionProjectSaleId'] = ProjectSaleId;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<number>(this.baseurl + "LeadTansaction/GetCountLeadTansaction", strjson, httpOptions)
        .toPromise().then(data => {
          //this.currentPageNumber_LeadTransac = 1;
          this.totalLeadTransaction = data;//จำนวน data ทั้งหมด
          if(this.totalLeadTransaction == 0) this.currentPageNumber_LeadTransac = 0;
          this.totalPages_LeadTransac = Math.ceil(this.totalLeadTransaction / environment.PageSizeSmall);//จำนวนที่แบ่ง page ได้
        });
    }
  }

  GetCommissionActualPrice() {
    var ActualPrice = this.CloseDealForm.get('ProjectSaleActualPrice');
    var Commissionpercentage = this.CloseDealForm.get('PorjectSaleCommission');
    var PriceofCommission = this.CloseDealForm.get('Commissiontotal');

    PriceofCommission.setValue(this.removeCommasReturn(ActualPrice) * (Commissionpercentage.value / 100));

    this.replaceCommas(PriceofCommission)
  }

  GetCommissionActualPricepercentage() {
    var ActualPrice = this.CloseDealForm.get('ProjectSaleActualPrice');
    var Commissionpercent = this.CloseDealForm.get('PorjectSaleCommission');
    var PriceofCommission = this.CloseDealForm.get('Commissiontotal');

    Commissionpercent.setValue(isNaN(this.removeCommasReturn(PriceofCommission) / this.removeCommasReturn(ActualPrice) * 100) == true ? 0 : this.removeCommasReturn(PriceofCommission) / this.removeCommasReturn(ActualPrice) * 100 == Infinity ? 0 : this.removeCommasReturn(PriceofCommission) / this.removeCommasReturn(ActualPrice) * 100 );
  }


  removeCommasReturn(ctrl) {
    //this.tempvariable = ctrl.value.toString();

    var result = ctrl.value.toString().replace(/,/g, '');
    return result;
  }

  replaceCommasReturn(ctrl) {
    if (isNaN(ctrl.value.toString())) {
      return this.tempvariable;
    } else {
      var result = ctrl.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      if (result.indexOf('.') < 0) {
        result += ".00";
      }
      return result;
    }

  }


  // Function on load on screen
  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }


  isFieldValid(field: string) {
    return !this.CloseDealForm.get(field).valid && this.CloseDealForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  checkpermissionactionbyOnHand() {
    var flagdisable = null;
    if ((this._Status != "3" && this._Status != "4" && this._Status != "0")) {
      flagdisable = true;
    } 

    return flagdisable;
  }

  DowloadProjectSaleAttachFile(ProjectSaleAttachmentId) {
    if (ProjectSaleAttachmentId != 0 && ProjectSaleAttachmentId != null) {
      window.open(this.baseurl + 'ProjectSaleAttachment/downloadfile/' + ProjectSaleAttachmentId + '', '_blank');

    }
  }

  GetTypeFile(filename) {
    var retruntypefile = '';
    var indexfind = -1;
    var extensionfile = this.GlobalService.getExtension(filename);
    var onlyone = ['css', 'csv', 'html', 'js', 'json', 'pdf', 'png', 'txt', 'xml', 'zip', 'rar', 'mp3', 'mp4'];
    var word = ['doc', 'docm', 'docx', 'dot', 'dotx'];
    var jpg = ['jpg', 'jpeg'];
    var powerpoint = ['pptx', 'pptm', 'ppt', 'ppsx', 'ppsm', 'pps', 'ppam', 'potx', 'potm', 'pot'];
    var Excel = ['xltx', 'xltm', 'xlt', 'xlsx', 'xlsm', 'xls', 'xlm', 'xll', 'xlam', 'xla'];

    // find from array onlyone
    indexfind = onlyone.findIndex(item => item == extensionfile);

    // not found
    if (indexfind == -1) {
      // check from array word
      indexfind = word.findIndex(item => item == extensionfile);
      if (indexfind != -1) {
        retruntypefile = 'word';
      } else {
        // check from array jpg
        indexfind = jpg.findIndex(item => item == extensionfile);

        if (indexfind != -1) {
          retruntypefile = 'jpg';
        } else {
          // check from array powerpoint
          indexfind = powerpoint.findIndex(item => item == extensionfile);

          if (indexfind != -1) {
            retruntypefile = 'ppt';
          } else {
            // check from array Excel
            indexfind = Excel.findIndex(item => item == extensionfile);

            if (indexfind != -1) {
              retruntypefile = 'xls';
            } else {
              retruntypefile = 'default';
            }

          }

        }
      }

    } else {
      // found item
      retruntypefile = extensionfile;
    }

    return retruntypefile;
  }

  // Function convert byte to size file
  formatBytes(byte) {
    return this.GlobalService.formatBytes(byte);
  }

  //เขียนใหม่
  async LoadProjectSaleDetails() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleCode'] = this._ProjectCode;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSaleWorklist",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.WorklistProjectSaleList = data; //เอาไว้ทำไมไม่รู้ แต่เอาไว้ก่อน
          this.InitialLeadForm(data); //อันนี้ใช้จริง
        });
    }
  }
  InitialLeadForm(projSaleList: ProjectSaleInfo[] = []) {
    this.CloseDealForm.reset();
    this.isOnUpdate = true;

    if (projSaleList.length > 0) {

      var projSaleDetail = projSaleList[0];


      this.CloseDealForm.patchValue({
        ProjectSaleCode: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleCode),
        ProjectSaleName: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleName),
        ProjectSaleCompany: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleCompanyDisplay),
        ProjectSaleEstimatePrice: projSaleDetail.ProjectSaleEstimatePrice != null ? projSaleDetail.ProjectSaleEstimatePrice : 0,
        ProjectSaleActualPrice: projSaleDetail.ProjectSaleActualPrice != null ? projSaleDetail.ProjectSaleActualPrice : 0,
        ProjectSaleEstimateTime: projSaleDetail.ProjectSaleEstimateTime != null ? projSaleDetail.ProjectSaleEstimateTime : 0,
        PorjectSaleCommission: this.GlobalService.checkUndefinedString(projSaleDetail.PorjectSaleCommission) != null ? parseInt(projSaleDetail.PorjectSaleCommission) : 0,
        ProjectStartDealDate: this.GlobalService.formatDate(projSaleDetail.ProjectStartDealDate),
        ProjectEndDealDate: this.GlobalService.formatDate(projSaleDetail.ProjectEndDealDate),
        ProjectHeadSale: '',
        ProjectLeadOwner: this.GlobalService.checkUndefinedString(projSaleDetail.ProjectSaleDisplayCreateBy),
      });

      this.hideProjectSaleRequestTypeCode = projSaleDetail.ProjectSaleRequestTypeCode;
      this.hideProjectSaleCloseDeaWFStatusCodeCurrent = projSaleDetail.ProjectSaleCloseDeaWfstatus;

      this.GetCommissionActualPrice();

      this.hidProjectSaleId = projSaleDetail.ProjectSaleId
      this.hideProjectSaleOnHand = projSaleDetail.ProjectSaleOnHand

      this.LoadProjectSaleAttachfileList().then(data => {
        this.ProjectSaleAttachmentList = data;

        // set progress 100 for attach file from database
        this.ProjectSaleAttachmentList.forEach((item, index) => {
          item.progress = 100;
        });
      });

      //load current transaction log list
      this.LoadTansaction('2', projSaleDetail.ProjectSaleId).then((data) => {
        this.LeadTransaction = data;
      });
      this.LoadCountTansaction('2', projSaleDetail.ProjectSaleId)


      //Is Re-Submit?
      if (projSaleDetail.ProjectSaleCloseDealCreateBy == this._EmpCode &&
        (projSaleDetail.ProjectSaleStatusWorkflowCode == "3" || projSaleDetail.ProjectSaleStatusWorkflowCode == "4")) {
        this.isReSubmit = true;
      }
    }

    this.OnLoadReplaceComma();
  }
  async OnBtnSubmitWorklist_Click() {
    if (this.CloseDealForm.valid  && (this.RadioVal != "3" || (this.RadioVal == "3" && this.RadioValChoice != ""))) {
      this.hideProjectSaleOnHand = "" // set hideOnHand to empty for diabled all control
      this.loading(true, 'Submiting ...');
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = this.hidProjectSaleId;
        objectjson['ProjectSaleEstimatePrice'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleEstimatePrice'].value) != "" ? this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleEstimatePrice'].value) : null;
        objectjson['ProjectSaleActualPrice'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleActualPrice'].value) != "" ? this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleActualPrice'].value) : null;
        objectjson['ProjectSaleEstimateTime'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleEstimateTime'].value) != "" ? this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['ProjectSaleEstimateTime'].value) : null;
        objectjson['PorjectSaleCommission'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['PorjectSaleCommission'].value);


        objectjson['ProjectSaleRequestTypeCode'] = this.hideProjectSaleRequestTypeCode;
        objectjson['Action'] = $('input[name="RadioAction"]:checked').val();
        objectjson['Comment'] = this.GlobalService.checkUndefinedString(this.CloseDealForm.controls['Comment'].value);
        objectjson['ProjectSaleCloseDeaWFStatusCodeCurrent'] = this.isReSubmit ? 1 : this.hideProjectSaleCloseDeaWFStatusCodeCurrent;
        objectjson['ResetFlow'] = this.RadioValChoice;

        objectjson['ProjectSaleUpdateBy'] = this.GlobalService.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleApprovalRequestId'] = Number(this._RequestId);
        objectjson['ProjectSaleReSubmit'] = this.isReSubmit;

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSaleWorklist", strjson, httpOptions)

          .subscribe(
          // 1) next: keep result + hide loading before then show modal + redirect
            result => {
              this.isSubmitted = result;
              this.loading(false);

              //console.log('Enter subscribe next, res=', this.isSubmitted.Value);
              let text = "Close Deal Request has been approved";
              if (this.isSubmitted.Value == "pending") text = "Close Deal Request pending approval";
              if (this.isSubmitted.Value == "success") text = "Close Deal Request has been approved";
              if (this.isSubmitted.Value == "reject")  text = "Close Deal Request has been rejected";
              if (this.isSubmitted.Value == "rework")  text = "Close Deal Request pending rework";

              this.titlemodal = text;
              this.detailmodal = '';
              this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });

              $('#ModalComplate').modal('show');

              $('#ModalComplate')
              .off('hidden.bs.modal')      // If have old binding => it will clear
              .one('hidden.bs.modal', () => {
              this.route.navigate(['/worklist-sale']);
              });
            },

          // 2) error: task
          failCb => {
            console.log("Update fail");
            this.loading(false);

            this.titlemodal = 'Submit lead approval fail.';
            this.detailmodal = 'Your task was submit fail.';
            this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });
            $('#ModalError').modal('show');
          }
        );
      }
    } else {
      this.GlobalService.validateAllFormFields(this.CloseDealForm);
      $('input.ng-invalid')[0].focus()
    }
  }
  OnBtnCancel_Click() {
    this.route.navigate(["/worklist-sale"]);
  }
  OnBtnBack_Click() {
    this.route.navigate(["/worklist-sale"]);
  }

  OnLoadReplaceComma() {
    var commissionfield = this.CloseDealForm.get('Commissiontotal');
    var saleactualpricefield = this.CloseDealForm.get('ProjectSaleActualPrice');
    var saleestpricefield = this.CloseDealForm.get('ProjectSaleEstimatePrice');

    this.replaceCommas(commissionfield);
    this.replaceCommas(saleactualpricefield);
    this.replaceCommas(saleestpricefield);
  }


  removeCommas(ctrl) {
    this.tempvariable = ctrl.value.toString();

    var result = ctrl.value.toString().replace(/,/g, '');
    ctrl.setValue(result);
  }

  replaceCommas(ctrl) {
    if (isNaN(ctrl.value.toString())) {
      ctrl.setValue(this.tempvariable);
      this.GetCommissionActualPrice()
    } else {
      var result = ctrl.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      if (result.indexOf('.') < 0) {
        result += ".00";
      }
      ctrl.setValue(result);
    }

  }

  SetRadioVal(){
    //console.log($('input[name="RadioAction"]:checked').val())

    //let test = $('input[name="RadioAction"]:checked').val();
    
    this.RadioVal = $('input[name="RadioAction"]:checked').val().toString();
    console.log(this.RadioVal)

    //return $('input[name="RadioAction"]:checked').val()
  }
}
